<script setup>
import { ref } from 'vue';
import Menu from './Menu.vue';
const isMenuOpen = ref(false);
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
defineProps({
  title: String,
});
defineEmits(['update:isMenuOpen']);
</script>

<template>
  <header class="w-full bg-emerald-400 text-white p-3 relative">
    <div class="flex justify-between items-center max-w-7xl mx-auto">
      <h1 class="text-3xl md:text-5xl font-bold">{{ title }}</h1>
      <button @click="toggleMenu" class="md:hidden p-2 focus:outline-none">
        <svg
          v-if="!isMenuOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <Menu :is-menu-open="isMenuOpen" />
    </div>
  </header>
</template>
